import _ from 'lodash'
import user from './user'
import client from './client'
import species from './species'
import categories from './categories'
import boat from './boat'

export default _.merge(user, client, species, categories, boat)
